module.exports = __webpack_public_path__ + "static/img/faq_about03.4d2781a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_about03.png
// module id = 9OL9
// module chunks = 2